<template lang="html">
  <div class="analytics-container">
    <div class="row col-xs no-margin no-padding">
      <adminPortalAnalyticsFiltersBar @date_filter="searchAnalytics" />
    </div>
    <div class="row mt4">
      <div class="col-xs-12 col-lg-8">
        <adminPortalAnalyticsGeneralInfo
          :activeTeachers="active_teachers"
          :activeStudents="active_students"
          :numberOnlineActivitiesRun="number_of_online_activities_run"
          :numberLiveActivitiesCreated="number_of_live_activities_created"
          :numberLiveActivitiesRun="number_of_live_activities_run"
          :numberOnlineActivitiesCreated="number_of_online_activities_created"
          :topicsUsed="topics_used"
        />
        <adminPortalAnalyticsNumberOfRtsGraph
          :analyticsNumberOfRts="analytics_number_of_rts"
        />
        <adminPortalAnalyticsTimeSpentOnParlayGraph
          :analyticsTimeSpentOnParlay="analytics_time_spent_on_parlay"
        />
        <onlineRoundtableEngagement
          :onlineRTEngagement="online_rt_engagement"
        />
        <liveRoundtableEngagement :liveRTEngagement="live_rt_engagement" />
      </div>
      <div class="col-xs-12 col-lg-4">
        <adminPortalAnalyticsTables
          :analyticsMostActiveTeachers="analytics_most_active_teachers"
          :analyticsInactiveTeachers="analytics_inactive_teachers"
          :analyticsRecentTopicsUsed="analytics_recent_topics_used"
          :analyticsTopUniversePortfolios="analytics_top_universe_portfolios"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import adminPortalAnalyticsFiltersBar from './adminPortalAnalyticsFiltersBar.vue';
  import adminPortalAnalyticsTables from './adminPortalAnalyticsTables.vue';
  import adminPortalAnalyticsGeneralInfo from './adminPortalAnalyticsGeneralInfo.vue';
  import adminPortalAnalyticsNumberOfRtsGraph from './standardGraphs/numberOfRtsGraph.vue';
  import adminPortalAnalyticsTimeSpentOnParlayGraph from './standardGraphs/timeSpentOnParlayGraph.vue';
  import onlineRoundtableEngagement from './engagementGraphs/onlineRoundtableEngagement.vue';
  import liveRoundtableEngagement from './engagementGraphs/liveRoundtableEngagement.vue';
  import adminServices from 'services/admin/adminServices';

  export default {
    components: {
      adminPortalAnalyticsFiltersBar,
      adminPortalAnalyticsGeneralInfo,
      adminPortalAnalyticsNumberOfRtsGraph,
      adminPortalAnalyticsTimeSpentOnParlayGraph,
      adminPortalAnalyticsTables,
      onlineRoundtableEngagement,
      liveRoundtableEngagement,
    },
    data() {
      return {
        analytics_number_of_rts: [],
        analytics_time_spent_on_parlay: [],
        analytics_most_active_teachers: [],
        analytics_inactive_teachers: [],
        analytics_recent_topics_used: [],
        analytics_top_universe_portfolios: [],
        active_teachers: 0,
        active_students: 0,
        number_of_online_activities_created: 0,
        number_of_online_activities_run: 0,
        number_of_live_activities_created: 0,
        number_of_live_activities_run: 0,
        topics_used: 0,
        online_rt_engagement: [],
        live_rt_engagement: [],
      };
    },

    methods: {
      searchAnalytics(values) {
        const schoolID = this.$route.params.schoolID;

        adminServices.getActiveTeachers(schoolID, values).then((res) => {
          this.active_teachers = res.data.active_teachers_count;
        });

        adminServices.getActiveStudents(schoolID, values).then((res) => {
          this.active_students = res.data.active_students_count;
        });

        adminServices.getDiscussionsCreated(schoolID, values).then((res) => {
          this.number_of_live_activities_created = res.data.discussions_count;
        });

        adminServices.getRoundtablesCreated(schoolID, values).then((res) => {
          this.number_of_online_activities_created = res.data.roundtables_count;
        });

        adminServices.getDiscussionsRun(schoolID, values).then((res) => {
          this.number_of_live_activities_run = res.data.discussions_count;
        });

        adminServices.getRoundtablesRun(schoolID, values).then((res) => {
          this.number_of_online_activities_run = res.data.roundtables_count;
        });

        adminServices.getUniverseTopicsUsed(schoolID, values).then((res) => {
          this.topics_used = res.data.universe_topics_used_count;
        });

        adminServices
          .getSchoolAnalyticsMostActiveTeachers(schoolID, values)
          .then((res) => (this.analytics_most_active_teachers = res.data));

        adminServices
          .getSchoolAnalyticsInactiveTeachers(schoolID, values)
          .then((res) => (this.analytics_inactive_teachers = res.data));

        adminServices
          .getSchoolAnalyticsRecentTopicsUsed(schoolID, values)
          .then((res) => (this.analytics_recent_topics_used = res.data));

        adminServices
          .getSchoolAnalyticsTopUniversePortfolios(schoolID)
          .then((res) => (this.analytics_top_universe_portfolios = res.data));

        adminServices
          .getSchoolAnalyticsNumberOfRts(schoolID, values)
          .then((res) => {
            this.analytics_number_of_rts = res.data;
          });

        adminServices
          .getSchoolAnalyticsTimeSpentOnParlay(schoolID, values)
          .then((res) => {
            this.analytics_time_spent_on_parlay = res.data;
          });

        this.getOnlineRoundtableEngagementData(values);
        this.getLiveRoundtableEngagementData(values);
      },

      getOnlineRoundtableEngagementData(values) {
        const schoolID = this.$route.params.schoolID;
        adminServices
          .getOnlineRoundtableEngagement(schoolID, values)
          .then((res) => {
            this.online_rt_engagement = res.data;
          });
      },
      getLiveRoundtableEngagementData(values) {
        const schoolID = this.$route.params.schoolID;
        adminServices
          .getLiveRoundtableEngagement(schoolID, values)
          .then((res) => {
            this.live_rt_engagement = res.data;
          });
      },
    },
    mounted() {},
  };
</script>

<style scoped lang="stylus">
  .analytics-container {
    margin: 3.1rem 2rem 2rem 2rem;
  }
</style>



// WEBPACK FOOTER //
// adminPortalAnalytics.vue?0a060613